import { recordPromoImpressions } from "~/redux/actions/app";

const trackedKeys = new Set();
const pendingBySource = new Map();
let flushTimer = null;

const FLUSH_DELAY_MS = 1000;

function flush() {
  flushTimer = null;

  pendingBySource.forEach((promoIds, source) => {
    if (promoIds.size === 0) return;

    const ids = Array.from(promoIds);
    promoIds.clear();

    recordPromoImpressions(ids, source).catch(() => {});
  });
}

function scheduleFlush() {
  if (flushTimer) return;
  flushTimer = setTimeout(flush, FLUSH_DELAY_MS);
}

export function trackPromoImpression(promoId, source = "web") {
  if (!promoId) return;

  const key = `${source}:${promoId}`;
  if (trackedKeys.has(key)) return;

  trackedKeys.add(key);

  if (!pendingBySource.has(source)) {
    pendingBySource.set(source, new Set());
  }

  pendingBySource.get(source).add(promoId);
  scheduleFlush();
}
